import React, { useState } from "react";
import { changeSortValue } from "../../../helpers/format";
interface IUseReusableTable {
  rows: any[];
  page?: number;
  createSortHandler?: (
    orderBy: string | null,
    orderType: string | null
  ) => void;
  orderBy?: string;
  orderType?: "asc" | "desc";
}

const useReusableTable = ({
  rows,
  page,
  createSortHandler,
  orderBy,
  orderType,
}: IUseReusableTable) => {
  const [selected, setSelected] = useState<number[]>([]);
  // const [page, setPage] = useState<number>(0);
  // const [data, setData] = useState<any>();
  const rowsPerPage = 15;
  // const onPageChange = (event: unknown, newPage: number) => {
  //   // setPage(newPage);
  // };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  const isSelected = (id: number) => selected.indexOf(id) !== -1;
  const handleItemClick = (event: React.MouseEvent<unknown>, id: number) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: number[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const onTableHeaderSortClicked = (columnId: string) => {
    if (createSortHandler) {
      if ((orderBy === columnId ? orderType : null) === "desc") {
        createSortHandler(null, null);
      } else {
        createSortHandler(
          columnId,
          changeSortValue(orderBy === columnId ? orderType : null)
        );
      }
    }
  };

  return {
    page,
    // onPageChange,
    rowsPerPage,
    isSelected,
    handleItemClick,
    handleSelectAllClick,
    selected,
    onTableHeaderSortClicked,
  };
};

export default useReusableTable;
